(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/subscription-router.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/subscription-router.js');
"use strict";


const _React = React,
  Fragment = _React.Fragment;
const Route = svs.app.ReactRouter.Route;
const _svs$ticketsOrderHome = svs.ticketsOrderHome.routes.SUBSCRIPTION,
  CHOOSE = _svs$ticketsOrderHome.CHOOSE,
  CONFIRMATION = _svs$ticketsOrderHome.CONFIRMATION;
const showTrissNextLobby = svs.ticketgames.ticketUtility.utils.showTrissNextLobby;
const NavigationBack = svs.tur.NavigationBack;
const branding = svs.tickets.data.templateConfig.branding === 'triss' ? 'triss' : null;
const isFeatureLobbyEnabled = showTrissNextLobby();
const getTrissMorePath = () => "".concat(svs.core.urlMapping.get('trissHome').replace(/\/$/, ''), "/mer");
const routes = {
  [CHOOSE]: {
    text: isFeatureLobbyEnabled ? 'Start' : 'Beställ hem/',
    path: () => isFeatureLobbyEnabled ? getTrissMorePath() : svs.core.data.baseUrl
  }
};
const breadcrum = 'Prenumeration';
const SubscriptionRouter = () => React.createElement(Fragment, null, React.createElement(NavigationBack, {
  brand: isFeatureLobbyEnabled ? 'next-lobby' : branding,
  breadcrum: isFeatureLobbyEnabled ? null : breadcrum,
  routes: routes
}), React.createElement(Route, {
  component: () => React.createElement("div", null, CHOOSE),
  path: CHOOSE
}), ' ', React.createElement(Route, {
  component: () => React.createElement("div", null, CONFIRMATION),
  path: CONFIRMATION
}), ' ');
setGlobal('svs.ticketsOrderHome.SubscriptionRouter', SubscriptionRouter);

 })(window);